import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { interval } from 'rxjs';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { UserService } from '../../../../../shared-components/user/user.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { Card } from '../../../card-container/card/card';
import { StudentSummaryService } from '../../../student-summary.service';
import { CardAnnouncement } from './card-announcement';
import { CardAnnouncementModalComponent } from './card-announcement-modal/card-announcement-modal.component';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-announcement-card',
    templateUrl: './announcement-card.component.html',
    styleUrls: ['./announcement-card.component.css']
})

export class AnnouncementCardComponent implements OnInit, OnDestroy {
    @ViewChildren('textArea') textAreas: QueryList<ElementRef>;
    @Input() data: any;
    card: Card;
    currentDate: any;
    announcements: CardAnnouncement[] = [];
    districtAnnouncements: CardAnnouncement[] = [];
    schoolAnnouncements: CardAnnouncement[] = [];
    classAnnouncements: CardAnnouncement[] = [];

    constructor(private matDialog: MatDialog, private router: Router, private userService: UserService, private yearService: YearService, private studentSummaryService: StudentSummaryService, private studentService: StudentService, private sanitizer: DomSanitizer) {
        this.currentDate = moment().format('MM/DD/YY');
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getAnnouncements();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    viewDetailsClick() {
        this.router.navigateByUrl('/student360/announcements');
    }

    checkOverflow(element) {
        if (element && (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth)) {
            return true;
        }
        else {
            return false;
        }
    }

    moreClick(announcement: CardAnnouncement) {
        this.matDialog.open(CardAnnouncementModalComponent, {
            data: announcement,
            disableClose: true,
            autoFocus: false,
            minWidth: '500px',
            maxWidth: '700px',
            maxHeight: '400px',
            minHeight: '300px'
        });
    }

    hasNewAnnouncements(announcements: CardAnnouncement[]) {
        const newAnnouncements = announcements.filter(a => a.IsNewSinceLastLogin == 1);
        if (newAnnouncements.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    getAnnouncements() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardAnnouncements(this.studentService.selectedStudent.Id, this.userService.currentUser.Id, schoolId, this.userService.userType, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                let idx = 0;
                this.announcements = response.body;
                this.districtAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'District');
                this.schoolAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'School');
                this.classAnnouncements = this.announcements.filter(a => a.AnnouncementType == 'Class');
                this.classAnnouncements.forEach(element => {
                    if (element.Announcement.indexOf('<span>') == -1 || element.Announcement.startsWith('<span>') == false) {
                        element.Announcement = '<span>' + element.Announcement + '</span>';
                    }
                });
                setTimeout(() => {
                    this.districtAnnouncements.forEach((announcement) => {
                        const ta = this.textAreas.toArray()[idx];
                        if (ta != undefined) {
                            announcement.Overflow = this.checkOverflow(ta.nativeElement);
                            idx++;
                        }
                    });
                    this.schoolAnnouncements.forEach((announcement) => {
                        const ta = this.textAreas.toArray()[idx];
                        if (ta != undefined) {
                            announcement.Overflow = this.checkOverflow(ta.nativeElement);
                            idx++;
                        }
                    });
                    this.classAnnouncements.forEach((announcement) => {
                        const ta = this.textAreas.toArray()[idx];
                        if (ta != undefined) {
                            announcement.Overflow = this.checkOverflow(ta.nativeElement);
                            idx++;
                        }
                    });
                }, 0);
            }
        });
    }

    transform(content) {
        return this.sanitizer.bypassSecurityTrustHtml(content);
    }

}
